import { AuthUserPermission, ContentfulApi } from '@cibo/core'
import { usePermissions } from '@cibo/profile'
import { FriendlyError } from '@cibo/ui'
import { Grid, Skeleton } from '@mui/material'
import { useQuery } from '@tanstack/react-query'
import { LearnArticleCard } from 'components/LearnArticleCard/LearnArticleCard'

interface LearnArticleListProps {
  limit?: number
}

export const LearnArticleList = ({ limit = 3 }: LearnArticleListProps) => {
  const { can } = usePermissions()
  const { data, isLoading, isError } = useQuery(['learn_articles'], () =>
    ContentfulApi.requestAll('learnArticle')
  )
  if (!can({ useAny: AuthUserPermission.LEARN_VIEW })) {
    return null
  }

  if (isLoading) {
    return (
      <Grid columns={{ xs: 4, md: 8, lg: 12 }} spacing={2} container>
        <Grid xs={4} item>
          <Skeleton variant="rounded" height={150} />
        </Grid>
        <Grid xs={4} item>
          <Skeleton variant="rounded" height={150} />
        </Grid>
      </Grid>
    )
  }

  if (isError) {
    return <FriendlyError message={'Error Loading'} />
  }

  const articles = data.slice(0, limit)

  return (
    <Grid columns={{ xs: 4, md: 8, lg: 12 }} spacing={2} container>
      {articles.map((entry: any) => (
        <Grid key={entry?.sys.id} xs={4} item container>
          <LearnArticleCard entry={entry} />
        </Grid>
      ))}
    </Grid>
  )
}
